import { Injectable } from '@angular/core';

/**
 * Service for extracting and transforming data from cotizacion objects
 * Handles combinaciones, unidades, contactos, and tipo de unidad extraction
 */
@Injectable()
export class CotizacionDataExtractorService {

    constructor() { }

    /**
     * Extracts tipo de unidad and cantidad from cotizacion
     * Iterates through precioCombinaciones to find first active unit type
     *
     * @param cotizacion Cotizacion object with serviciosArreglo
     * @returns Object with tipoDeUnidad and cantidad
     */
    extractTipoDeUnidad(cotizacion: any): { tipoDeUnidad: string; cantidad: number } {
        const combinacion = cotizacion.serviciosArreglo[0].precioCombinaciones;
        let tipoDeUnidad = "";
        let cantidad = 0;

        Object.keys(combinacion).forEach(key => {
            const objCombinacion = combinacion[key];
            Object.keys(objCombinacion.combinacion).forEach(keyC => {
                if (objCombinacion.combinacion[keyC] > 0) {
                    tipoDeUnidad = keyC;
                    cantidad = objCombinacion.combinacion[keyC];
                }
            });
        });

        return { tipoDeUnidad: tipoDeUnidad, cantidad: cantidad };
    }

    /**
     * Extracts tipo de unidad from selected combinacion
     *
     * @param cotizacion Cotizacion object
     * @param combinacionSeleccionada ID of selected combinacion
     * @returns Object with tipoDeUnidad and cantidad
     */
    extractTipoUnidadFromCombinacion(cotizacion: any, combinacionSeleccionada: string): { tipoDeUnidad: string; cantidad: number } {
        const combinacion = cotizacion.serviciosArreglo[0].precioCombinaciones;
        const objCombinacion = combinacion[combinacionSeleccionada];

        let tipoDeUnidad = '';
        let cantidad = 0;

        Object.keys(objCombinacion.combinacion).forEach(keyC => {
            if (objCombinacion.combinacion[keyC] > 0) {
                tipoDeUnidad = keyC;
                cantidad = objCombinacion.combinacion[keyC];
            }
        });

        return { tipoDeUnidad: tipoDeUnidad, cantidad: cantidad };
    }

    /**
     * Converts precioCombinaciones object to array format
     * Useful for ngFor iteration in templates
     *
     * @param precioCombinaciones Object with combinaciones
     * @returns Array of combinaciones with id property
     */
    convertCombinacionesToArray(precioCombinaciones: any): any[] {
        const combinacionesArray = [];
        Object.keys(precioCombinaciones).forEach(key => {
            combinacionesArray.push({ id: key, ...precioCombinaciones[key] });
        });
        return combinacionesArray;
    }

    /**
     * Extracts first palabra (word) from zona/punto origen nombre
     * Used to determine if origin is Qro, CDMX, or Toluca
     *
     * @param nombrePunto Full punto origen name
     * @returns First word (e.g., "Qro", "CDMX", "Toluca")
     */
    extractPrimeraPalabraZona(nombrePunto: string): string {
        if (!nombrePunto) return '';
        return nombrePunto.trim().split(' ')[0];
    }

    /**
     * Determines office/zone from punto origen
     *
     * @param nombrePunto Punto origen nombre
     * @returns "QUERETARO" or "TC CDMX"
     */
    determineOfficeFromPuntoOrigen(nombrePunto: string): string {
        const primeraPalabra = this.extractPrimeraPalabraZona(nombrePunto);

        if (primeraPalabra === 'Qro') {
            return "QUERETARO";
        } else if (primeraPalabra === 'CDMX' || primeraPalabra === 'Toluca') {
            return "TC CDMX";
        }

        return "TC CDMX"; // Default
    }

    /**
     * Extracts zona cotizacion (id_punto_origen) as string
     *
     * @param cotizacion Cotizacion object
     * @returns Zona ID as string or null
     */
    extractZonaCotizacion(cotizacion: any): string | null {
        const idPuntoOrigen = cotizacion.serviciosArreglo[0].punto_origen.id_punto_origen;
        return idPuntoOrigen ? String(idPuntoOrigen) : null;
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/helpers/cotizacion-data-extractor.service.ts